module.exports = __webpack_public_path__ + "static/5-d752f04fee77f6c2fa425d89e1df43bf.jpg";